import { CURRENCY_LABEL } from '../constants/currency';

const DEPOSIT_CONVERTED_AMOUNT_REGEX = /converted to\s+(\d+(?:[.,]\d+)?)\s*(D10S|DIOS10|DIOS)/i;

export const getTransactionDisplayAmount = (entry) => {
  if (!entry) return 0;

  const description = String(entry.description || '');
  const isDeposit = String(entry.action || entry.type || '').toLowerCase() === 'deposit';

  if (isDeposit) {
    const match = description.match(DEPOSIT_CONVERTED_AMOUNT_REGEX);
    if (match?.[1]) {
      const parsed = Number(match[1].replace(',', '.'));
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }
  }

  const amount = Number(entry.amount ?? 0);
  return Number.isFinite(amount) ? amount : 0;
};

export const getTransactionDisplayCurrency = (entry) => {
  if (!entry) return CURRENCY_LABEL;

  const description = String(entry.description || '');
  const isDeposit = String(entry.action || entry.type || '').toLowerCase() === 'deposit';

  if (isDeposit && DEPOSIT_CONVERTED_AMOUNT_REGEX.test(description)) {
    return CURRENCY_LABEL;
  }

  const currency = String(entry.currency || '').toUpperCase();
  if (currency === 'D10S' || currency === 'DIOS10') {
    return CURRENCY_LABEL;
  }

  return currency || CURRENCY_LABEL;
};
